import React from 'react';
import styled from 'styled-components';

const CategoryManagementContainer = styled.div`
  background-color: white;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const Title = styled.h2`
  margin: 0 0 20px 0;
  color: #2c3e50;
`;

const CategoryManagement = () => {
  return (
    <CategoryManagementContainer>
      <Title>카테고리 관리</Title>
      <p>카테고리 관리 페이지입니다.</p>
    </CategoryManagementContainer>
  );
};

export default CategoryManagement;

